/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USER_LIST = gql`
  query GetUserList($input: GetUserListInput) {
    getUserList(input: $input) {
      currentPage
      pageSize
      totalCount
      totalPages
      data {
        vuid
        userId
        email
        firstName
        lastName
        fullName
        emailVerified
        kycSubmitted
        createdAt
        image
        accountStatus
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
        }
      kyc {
        docs {
          comment
          status
          doc
          type
          name
        }
    }
        occupation
        primaryContactNo
        suspended
      }
    }
  }
`;
